import script from "./DashboardChatTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardChatTabs.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardChatTabs.vue?vue&type=style&index=0&id=462f6e91&lang=css"

const __exports__ = script;

export default __exports__